import script from "./AppUpdateBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppUpdateBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AppUpdateBanner.vue?vue&type=style&index=0&id=698f17f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-698f17f9"]])

export default __exports__